import { createAction } from "@reduxjs/toolkit";
import axios from 'apis';
import { asyncThunkWrapper } from "helpers/asyncThunkWrapper";

export const getPenStudyFlow = asyncThunkWrapper({ 
  model: 'penStudyFlows', 
  action: 'getPenStudyFlow', 
  func: async () => {
    const params = { attributes: ['id', 'before_in', 'start_at', 'time_zone', 'prompt', 'upload', 'updated_at'] };
    const response = await axios.get(`/pen_study_flow`, { params });

    return response.data;
  } 
});
export const createPenStudyFlow = asyncThunkWrapper({ 
  model: 'penStudyFlows', 
  action: 'createPenStudyFlow', 
  func: async (pen_study_flow) => {
    const attributes = ['id', 'before_in', 'start_at', 'time_zone', 'prompt', 'upload', 'updated_at'];
    const response = await axios.post(`/pen_study_flow`, { pen_study_flow, attributes });

    return response.data;
  } 
});
export const updatePenStudyFlow = asyncThunkWrapper({ 
  model: 'penStudyFlows', 
  action: 'updatePenStudyFlow', 
  func: async (pen_study_flow) => {
    const response = await axios.patch(`/pen_study_flow`, { pen_study_flow });

    return { status: response.status, pen_study_flow };
  } 
});
export const deletePenStudyFlow = asyncThunkWrapper({ 
  model: 'penStudyFlows', 
  action: 'deletePenStudyFlow', 
  func: async () => {
    const response = await axios.delete(`/pen_study_flow`);

    return { status: response.status };
  } 
});
export const clearLocalActivePenStudyFlow = createAction('penStudyFlows/clearLocalActivePenStudyFlow');